<template>
  <component
    class="lcu-progress-card"
    :class="[classes]"
    :is="cardType.element" :to="cardType.link">
    <div
      class="lcu-card-image"
      :style="{
        backgroundImage: `url(${card.image})`,
        backgroundSize: bgSize,
      }">
      <span
        class="lcu-card-progress"
        v-if="card.progress"
        :class="[`lcu-progress-${card.progress}`]">
        {{ localize(card.progress) }}
      </span>
    </div>
    <div class="lcu-card-textBox">
      <span class="lcu-card-header">{{ card.header }}</span>
      <span class="lcu-card-subHeader">
        <span class="lcu-card-icon" v-if="card.icon" />
        {{ card.subHeader }}
      </span>
    </div>
  </component>
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
  name: 'progress-card',
  computed: {
    cardType() {
      return {
        element: this.card.link ? RouterLink : 'div',
        link: this.card.link || null,
      };
    },
  },
  props: {
    card: {
      type: Object,
      required: false,
      default: () => ({
        image: '/assets/default-card.png',
        header: 'Header',
        subHeader: 'Sub header',
        progress: 'completed',
        link: '#',
        icon: true,
      }),
    },
    bgSize: {
      type: String,
      required: false,
      default: '',
    },
    classes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    localize(text) {
      if (text === 'inProgress') return 'En progreso';
      if (text === 'completed') return 'Completado';
      return text;
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-progress-card {
  border: 1px solid $page-border;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  height: 350px;
  overflow: hidden;
  text-decoration: none;
  color: $legacy-primary;
}

.lcu-card-image {
  background-size: cover;
  background-attachment: inherit;
  background-position: center center;
  background-repeat: no-repeat;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 10px 20px;
}

.lcu-card-progress {
  text-transform: capitalize;

  &:before {
    font-size: 24px;
    display: inline-block;
    position: relative;
    top: 3px;
    content: '\2022';
    margin: 0;
  }
}

.lcu-progress-inProgress {

  &:before {
    color: $progress-orange;

  }
}

.lcu-progress-completed {

  &:before {
    color: $progress-green;
  }
}

.lcu-card-textBox {
  border-top: 1px solid $page-border;
  padding: 20px;
  transition: background-color .2s;
}

.lcu-progress-card {
  &:hover {
    .lcu-card-textBox {
      background-color: $off-white;
    }
  }
}

.lcu-card-header {
  display: block;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
}

.lcu-card-subHeader {
  display: block;
  font-size: 14px;
}

.lcu-card-icon {

  &:before {
    font-family: 'lcu';
    display: inline-block;
    content: '\e809';
    margin-right: 5px;
    margin-left: 0;
  }
}
</style>
